module.exports = __webpack_public_path__ + "img/noun-advancement-5750290.9d2a5dcd.svg";